import { http } from "../http-common";

const ManageUnannouncedVisitorService = {
    getCropYears: async () => {
        try {
            const response = await http.get("/cropYears");
            return response;
        } catch (error) {
            throw error;
        }
    },

    getCropStage: async (params) => {
        try {
            const response = await http.get(`/crop-stage-calendar/crop-stage-calendar-drop-down?cropYear=${params.cropYear}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getVisitorList: async (params) => {
        try {
            const response = await http.get(`/manageUnannouncedVisit`, { params });
            return response;
        } catch (error) {
            throw error;
        }
    },

    getHierarchyDropdown: async (data) => {
        try {
            const response = await http.get(`/hierarchy/hierarchy-drop-down?isMuv=${data.isMuv}`);
            return response;
        } catch (error) {
            throw error;
        }
    },

    updateVisitorAssignment: async (visitorData) => {
        try {
            console.log("visitorData", visitorData);
            const response = await http.post("/manageUnannouncedVisit", visitorData);
            return response;
        } catch (error) {
            throw error;
        }
    },
};

export default ManageUnannouncedVisitorService;